import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { BasicNumber } from '@dbk/ui-numbers';
import { IntlProvider } from '@dbk/format';
import { Large, Small } from '../../../../../../../src/components/common/text';
import { View } from 'react-native';
import AssetItem from '../../../../../../../src/components/asset/asset-item';
import {
  AssetItemHeaderDescription,
  AssetItemHeaderChange,
  AssetItemCurrencyData ,
} from '../../../../../../../src/components/asset/asset-item/asset-item-header';
import {
  AssetItemDataText,
  AssetItemDataChange,
} from '../../../../components/asset/asset-item/asset-item-data';

import { AbbreviatedNumber, Percent, Currency } from '../../../../../../../src/components/common/number';
import TableRow from '../../../../../../../src/components/common/table-row';

import styles from './asset-position.styles';

class AssetPosition extends PureComponent {
  static propTypes = {
    row: PropTypes.shape({
      name: PropTypes.string,
      quantity: PropTypes.number,
      marketValue: PropTypes.number,
      unrealisedGL: PropTypes.number,
      unrealisedGLPercent: PropTypes.number,
      proportion: PropTypes.number,
    }),
    columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
    screen: PropTypes.shape({
      isSmall: PropTypes.bool,
    }),
  };

  static defaultProps = {
    row: {},
  };

  render() {
    const { row, columnWidths, screen, assetGroupId, assetShortDesc, assetCategory, selectedFirstLevelAsset, langCode } = this.props;
    const {
      name,
      quantity,
      marketValue,
      unrealisedGL,
      unrealisedGLPercent,
      proportion,
      isin,
      availableBalance,
      accruedInterest,
      balance,
      depositeAmount,
      positionCurrency
    } = row;
    let shorten = true;
    if (screen.isSmall) {
      shorten = 30;
    }

    let displaylnc = false;
    if (selectedFirstLevelAsset == 'liquidity') {
      displaylnc = true;
    } else {
      displaylnc = false;
    }
    const quantityArr = quantity && quantity.toString().split('.');
    // EBANK-19652
    const minDecimalReq = Array.isArray(quantityArr) && quantityArr.length > 1 ? quantityArr[1].length : 2;
    return (
      <AssetItem>
        {
          screen.isSmall &&
          <View>
            <TableRow style={styles.topRow}>
              <TableRow.Column
                align="left"
                width={columnWidths[0] + columnWidths[1]}
                testID="description"
              >
                <AssetItemHeaderDescription
                  row={{
                    description: name,
                  }}
                  shorten={shorten}
                />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[2]}>
                <AssetItemHeaderChange value={unrealisedGLPercent} />
              </TableRow.Column>
            </TableRow>

            <TableRow style={styles.bottomRow}>
            <TableRow.Column
                    align="left"
                    width={1}
                  >
                      <AssetItemCurrencyData
                  row={{
                    description: positionCurrency,
                  }}
                />
            </TableRow.Column>

            <TableRow.Column
                    align="left"
                    width={1}
                  >
                    <AssetItemDataText
                      value={quantity} />
                  </TableRow.Column>

                  <TableRow.Column width={columnWidths[1]}>
                <AssetItemDataText value={marketValue} />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[2]}>
                <AssetItemDataChange value={unrealisedGL} />
              </TableRow.Column> 

              {/* {
                displaylnc ?
                  <TableRow.Column
                    align="left"
                    width={1}
                  >
                    <Currency
                      value={quantity}
                      currency={positionCurrency}
                    />
                  </TableRow.Column> :
                  <TableRow.Column
                    align="left"
                    width={1}
                  >
                    <AssetItemDataText
                      value={quantity} />
                  </TableRow.Column>
              }
              <TableRow.Column width={columnWidths[1]}>
                <AssetItemDataText value={marketValue} />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[2]}>
                <AssetItemDataChange value={unrealisedGL} />
              </TableRow.Column> */}
            </TableRow>
          </View>
        }
        {
          !screen.isSmall &&
          <View>
            <TableRow style={styles.topRow}>
              <TableRow.Column
                align="left"
                width={1}
                testID="description"
              >
                <AssetItemHeaderDescription
                  row={{
                    description: name,
                  }}
                />
              </TableRow.Column>
            </TableRow>
            <TableRow style={styles.bottomRow}>
            <TableRow.Column
                    align="left"
                    width={columnWidths[0]}
                  >
                      <AssetItemCurrencyData      //WMCE-21562--for adding Currency column in front of  quantity column.
                  row={{
                    description: positionCurrency,
                  }}
                />
            </TableRow.Column>

            <TableRow.Column
                   
                    width={columnWidths[1]}
                    gutter={false}
                  >
                    
            {/* <AssetItemDataText
                value={quantity} /> */}

               <IntlProvider locale={langCode}>
                      <BasicNumber
                        value={quantity}
                        minimumFractionDigits={minDecimalReq}
                        renderProps={{
                          className: 'small'
                        }}
                      />
                    </IntlProvider>

            </TableRow.Column>
              {/* {
                displaylnc ?<div>
                  <TableRow.Column
                    align="left"
                    width={columnWidths[0]}
                  >
                      <AssetItemHeaderDescription
                  row={{
                    description: positionCurrency,
                  }}
                />
                  </TableRow.Column>

                  <TableRow.Column
                    align="left"
                    width={columnWidths[1]}
                  >
                    
                    <AssetItemDataText
                value={quantity} />
                  </TableRow.Column> </div>
                  :
                  <TableRow.Column
                    align="left"
                    width={columnWidths[0]}
                  >
                  
                    <IntlProvider locale={langCode}>
                      <BasicNumber
                        value={quantity}
                        minimumFractionDigits={minDecimalReq}
                        renderProps={{
                          className: 'large primary'
                        }}
                      />
                    </IntlProvider>

                  </TableRow.Column>
              } */}
              <TableRow.Column width={columnWidths[2]} gutter={false}>
                <AssetItemDataText value={marketValue} />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[3]} gutter={false}>
                <AssetItemDataChange value={unrealisedGL} />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[4]} gutter={false}>
                <AssetItemHeaderChange value={unrealisedGLPercent} />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[5]}>
                <Percent
                  value={proportion} 
                  renderProps={{ size: 'small' }}
                  />
              </TableRow.Column>
            </TableRow>
          </View>
        }
      </AssetItem>
    );
  }
}

export default AssetPosition;
